import { useAccordion } from '../../../customHook.js/useAccordion'
import useScrollAnimation from '../../../customHook.js/useScrollAnimation'

import RenderContent from '../../../helpers/RenderContent'
import { highlightText } from '../../../helpers/helperFunctions'

import { food1 } from '../../../const/contentData'
import openingParagraph from '../../../const/openingParagraph'
import modelRTL from '../../../const/modelRTL'
import food from '../../../images/food.jpg'
import foodS from '../../../images/food.svg'
import coffee from '../../../images/coffeeShop.png'
import pokeVan from '../../../images/pokeVan.JPG'
import buckaroo from '../../../images/buckaroo.JPG'
import classes from '../content.module.css'
import fclasses from './food.module.css'

function Food({ searchTerm }) {
  const moduleName = 'food'

  const { selectedRow, highlightedText, changeSelectedRow } = useAccordion(
    moduleName,
    searchTerm,
    0
  )

  const getToContainer = useScrollAnimation(moduleName)

  return (
    <div
      className={`${classes.main_container} ${
        !modelRTL[moduleName] && 'row_reverse'
      }`}
      id={moduleName}
    >
      <div
        className={`${classes.text_area} ${
          modelRTL[moduleName] ? classes.hidden_left : classes.hidden_right
        } ${getToContainer && classes.visible}`}
        dir="rtl"
      >
        <p className="fw_500">
          {highlightText(openingParagraph.food[0], highlightedText)}
        </p>
        <p className="fw_700">
          {highlightText(openingParagraph.food[1], highlightedText)}
        </p>
        <div className={classes.drop_down_section}>
          <div className="c_blue">
            <img className={classes.section_img} src={foodS} alt="food" />
          </div>
          <div>
            {food1.map(({ id, title, content, uniqueId }) => (
              <div key={id} id={uniqueId}>
                <div
                  className={`${classes.drop_down_title}  ${
                    selectedRow === id && classes.drop_down_open
                  } c_pink`}
                  onClick={() => changeSelectedRow(id)}
                >
                  <div className={classes.toggle_icon_container}>
                    <span
                      className={`${classes.toggle_icon} ${
                        selectedRow !== id && classes.visible
                      }`}
                    >
                      +
                    </span>
                    <span
                      className={`${classes.toggle_icon} ${
                        selectedRow === id && classes.visible
                      }`}
                    >
                      -
                    </span>
                  </div>
                  {highlightText(title, highlightedText)}
                </div>
                <div
                  className={`${classes.text_container} ${
                    selectedRow === id && classes.show
                  }`}
                >
                  <RenderContent
                    content={content}
                    searchTerm={highlightedText}
                  />
                  {uniqueId === 'food_4' && (
                    <img className={fclasses.coffee} src={coffee} alt="food" />
                  )}
                  {uniqueId === 'food_5' && (
                    <img className={fclasses.coffee} src={pokeVan} alt="food" />
                  )}
                  {uniqueId === 'food_6' && (
                    <img
                      className={fclasses.coffee}
                      src={buckaroo}
                      alt="food"
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div
        className={`${classes.main_img_container} ${
          modelRTL[moduleName] ? classes.hidden_right : classes.hidden_left
        }  ${getToContainer && classes.visible}`}
        dir="rtl"
      >
        <img src={food} alt="food" />
        <div>
          <h2>אוכלים שותים</h2>
          <h2>ואוהבים את זה!</h2>
        </div>
      </div>
    </div>
  )
}

export default Food
